import {setMeta} from '@/helpers/metaHelpers'
export default {
    watch: {
        '$page'() {
            if (this.$page) {
                setMeta(this.$page.seo);
            }
        }
    }
}